<section class="col-xs-12 col-sm-12 returns_titlesection" id="forUKReturns" >
  @if (this.pageLabel  != 'returnsDashboardThankYouPage') {
    <div class="returns_header">{{"returnsUK.title" | cxTranslate}}</div>
  }
  @if (this.pageLabel === 'returnsDashboardThankYouPage') {
    <div class="returns_header">{{"returnsUK.announcements" | cxTranslate}}</div>
  }
</section>
<div class="clearboth"></div>
